<template>
  <div id="app">
    <!--Условие для одной кучи камней-->
    <div v-if='game.type==1'>
      <p><span class='number'>19</span> Два игрока, Петя и Ваня, играют в следующую игру. Перед игроками лежит куча камней. Игроки ходят по очереди, первый ход делает Петя. За один ход игрок может <span class='bolder'>{{moveTxt}}</span></p>
      <p>Например, имея кучу из 10 камней, за один ход можно получить кучу из {{10+game.a}} или {{10*game.b}} камней. У каждого игрока, чтобы делать ходы, есть неограниченное количество камней.</p>
      <p>Игра завершается в тот момент, когда количество камней в куче становится не менее {{game.winS}}. Победителем считается игрок, сделавший последний ход, то есть первым получивший кучу, в которой будет {{game.winS}} или больше камней. В начальный момент в куче было S камней, 1 ≤ S ≤ {{game.winS-1}}</p>
    </div>
   
    <!--Условие для двух куч камней-->
    <div v-if='game.type==2'>
      <p><span class='number'>19</span> Два игрока, Петя и Ваня, играют в следующую игру. Перед игроками лежат две кучи камней. Игроки ходят по очереди, первый ход делает Петя. За один ход игрок может <span class='bolder'>{{moveTxt}}</span>.</p>
      <p>Например, пусть в одной куче 6 камней, а в другой 9 камней; такую позицию мы будем обозначать (6, 9). За один ход из позиции (6, 9) можно получить любую из четырёх позиций: ({{6+game.a}},9), ({{6*game.b}},9), (6,{{9+game.a}}), (6,{{9*game.b}}). Чтобы делать ходы, у каждого игрока есть неограниченное количество камней.</p>
      <p>Игра завершается в тот момент, когда суммарное количество камней в кучах становится не менее {{game.winS}}. Победителем считается игрок, сделавший последний ход, то есть первым получивший позицию, в которой в кучах будет {{game.winS}} или больше камней. В начальный момент в первой куче было {{game.heap[0][0]}} камней, во второй куче – S камней, 1 ≤ S ≤ {{game.winS-game.heap[0][0]-1}}.</p>
    </div>
   
    <!--Общее условие и задание-->
    <p>Говорят, что игрок имеет <span class='bolder'>выигрышную стратегию</span>, если он может выиграть при любых ходах противника. Описать стратегию игрока – значит описать, акой ход он должен сделать в любой ситуации, которая ему может встретиться при различной игре противника.</p>
    <p v-if="game.answer.step2.length>0">Укажите {{valueTxt(game.answer.step2)}} S, при которых Петя не может выиграть за один ход, но при любом ходе Пети Ваня может выиграть своим первым ходом. Опишите выигрышную стратегию Вани.</p>
    <p v-else>Известно, что Ваня выиграл своим первым ходом после неудачного первого хода Пети. Укажите минимальное значение S, когда такая ситуация возможна.</p>
    <p><span class='number'>20</span> Укажите {{valueTxt(game.answer.step3)}} S, при которых у Пети есть выигрышная стратегия, причём Петя не может выиграть первым ходом, но Петя может выиграть своим вторым ходом, независимо от того, как будет ходить Ваня. Для указанных значений S опишите выигрышную стратегию Пети.</p>
    <p><span class='number'>21</span> Укажите {{valueTxt(game.answer.step4)}} S, при котором у Вани есть выигрышная стратегия, позволяющая ему выиграть первым или вторым ходом при любой игре Пети, и при этом у Вани нет стратегии, которая позволит ему гарантированно выиграть первым ходом. Для указанных значений S опишите выигрышную стратегию Вани. Постройте дерево всех партий, возможных при этой выигрышной стратегии Вани (в виде рисунка или таблицы). На рёбрах дерева указывайте, кто делает ход, в узлах – количество камней в позиции.</p>
  
    <!--Решение задания -->
    <span class='hintButton'  v-on:click='answer = !answer'>Примерное решение</span>
    <div v-if='answer'>
      <div class="code" v-html="game.code"></div>
      <br>
      <p>Ответ<br/>
      <span v-if="game.answer.step2.length>0">19 [{{enumeration(game.answer.step2)}}]</span>
      <span v-else>19 {{game.answer.step21[0][1]}}</span><br/>
      20 [{{enumeration(game.answer.step3)}}]<br/>
      21 [{{enumeration(game.answer.step4)}}]</p>
      <!--<p>1а) При S = {{interval(game.answer.step1)}} Петя выигрывает первым ходом (увеличивает кучу камней в {{game.b}} раза)</p>
      <p>1б) При S = {{enumeration(game.answer.step2)}} Ваня выигрывает первым ходом при любой игре Пети</p>
      <div v-html = 'getStrategy(game.answer.step2)'></div>
      <p>2) При S = {{enumeration(game.answer.step3)}} Петя имеет стратегию, позволяющую ему выиграть своим вторым ходом при любой игре Вани</p>
      <div v-html = 'getStrategy(game.answer.step3)'></div>
      <p>3) При S = {{enumeration(game.answer.step4)}} Ваня имеет стратегию, позволяющую ему, в зависимости от игры Пети, выиграть своим первым или вторым ходом</p>
      <div v-html = 'getStrategy(game.answer.step4)'></div>-->
    </div>
  </div>

</template>

<script>
import game from './generator'

const n1 = ['один камень', 'два камня', 'три камня','четыре камня', 'пять камней']
const n2 = ['два раза', 'три раза', 'четыре раза']
const n3 = ['одно значение', 'два значения', 'три значения', 'четыре значения', 'пять значений', 'шесть значений', 'семь значений', 'восемь значений', 'девять значений', 'десять значений']

export default {
  name: 'App',
  data: ()=> {
    return {
      game,
      answer:false,
      n1, n2, n3
    }
  },
  computed: {
    moveTxt() {
      let s = (game.type==1) ? 'добавить в кучу ' : 'добавить в одну из куч '
      return s+`${n1[game.a-1]} или увеличить количество камней в куче в ${n2[game.b-2]}`
    }
  },
  methods: {
    valueTxt(arr) {return n3[arr.length-1]},
    interval(arr) {return (game.type==1) ? `${arr[0]}...${arr[arr.length-1]}` : `${arr[0][1]}...${arr[arr.length-1][1]}`},
    enumeration(arr) {
      let s=''
      arr.forEach(el=>s+=el[1] ? el[1]+', ' : el+', ')
      return s.substr(0,s.length-2)
    },
    getStrategy(step) {
      let html = ''
      step.forEach(el=>{
        // eslint-disable-next-line no-undef
        let strategy = Viz(this.game.plotGraph(el),{format:'svg'})
        html+=strategy
      })
      return html
    }
  }
}
</script>

<style src='./App.css'/>
